var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { MDCTabBar } from '@material/tab-bar';
import { MDCTabScroller } from '@material/tab-scroller';
import Tab from './Tab';
/**
 * Menu Component, uses icon component, allows to build custom menus
 *
 * **Functional Spec:** https://github.com/invotra/invotra-components-spec/blob/v0.2.1/content/components/tabbar.md
 */
var TabBar = /** @class */ (function (_super) {
    __extends(TabBar, _super);
    function TabBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabBar.prototype.componentDidMount = function () {
        var _this = this;
        if (this.tabBar) {
            var tabBar = MDCTabBar.attachTo(this.tabBar);
            tabBar.listen('MDCTabBar:activated', function (event) {
                _this.props.onActivate(event.detail.index);
            });
        }
        this.scroller && MDCTabScroller.attachTo(this.scroller);
    };
    TabBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, tabs = _a.tabs, _b = _a.activeTab, activeTab = _b === void 0 ? 0 : _b, _c = _a.stacked, stacked = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
        return (React.createElement("div", { className: "madonna-tab-bar mdc-tab-bar " + className, role: "tablist", "aria-orientation": "horizontal", ref: function (el) { _this.tabBar = el || undefined; } },
            React.createElement("div", { className: "mdc-tab-scroller", ref: function (el) { _this.scroller = el || undefined; } },
                React.createElement("div", { className: "mdc-tab-scroller__scroll-area" },
                    React.createElement("div", { className: "mdc-tab-scroller__scroll-content" }, tabs.map(function (tab, index) { return (React.createElement(Tab, { key: index, index: index, activeTab: activeTab, tab: tab, stacked: stacked })); }))))));
    };
    return TabBar;
}(React.Component));
export default TabBar;
//# sourceMappingURL=TabBar.js.map